import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import CardsGridUniDriver from './CardsGrid.uni.driver';

export function GridFoldersSectionUniDriver(base: UniDriver, body: UniDriver) {
  const refreshLoader = () => base.$('[data-hook="refresh-loader"]');

  return {
    ...baseUniDriverFactory(base),
    /** Gets a [CardsGridUniDriver]() for the section */
    grid: () => CardsGridUniDriver(base, body),
    /** Indicates the section header exists */
    headerExists: () => base.$('[data-hook="section-header"]').exists(),
    /** Indicates a skeleton loader exists */
    refreshLoaderExists: () => refreshLoader().exists(),
  };
}
